import * as Yup from "yup";

export const Add_Vehicle_validationSchema = Yup.object().shape({
  UserId: Yup.string().required("Account is required").min(2, "Account must be at least 2 characters long"),
  Vehicle_No: Yup.string()
    .required("Vehicle Number is required")
    .min(4, "Vehicle Number must be at least 1 character long"),
  Payload_Capacity: Yup.number().required("Payload Capacity is required").positive("Payload Capacity must be positive"),
  // Assuming Payload Capacity is measured in MT and needs to be a number
});

const Vehicle_Managent_Inputs = [
  {
    id: Math.random() * 10,
    name: "Vehicle_Category_Master",
    fields: [
      {
        id: Math.random() * 10,
        name: "Account_ID",
        label: "Account",
        type: "InputDropForQuery",
        masterName: "Search_Accounts_By_Profile_Type",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        isRequired: true,
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Nick_Name",
        label: "Nick Name",
        type: "text",
        min: 1,
        max: Infinity,
        isRequired: false,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Vehicle_No",
        label: "Vehicle No",
        type: "text",
        AllCaps: true,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Vehicle_Length",
        label: "Vehicle Length(FT)",
        type: "number",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Payload_Capacity",
        label: "Payload Capacity(MT)",
        type: "number",
        min: 1,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

export { Vehicle_Managent_Inputs };
